import React, { Component } from "react";
import modelCloseIcon from "../../../include/images/modal-close-icon.svg";
import { Modal } from "react-bootstrap";
import mindIcon from "../../../include/images/expert-mind-icon.svg";
import { getMisc, customerQuery } from "../../../store/misc";
import { connect } from "react-redux";

class Thoughts extends Component {
  state = {
    formModel: false,
    formSuccessModel: false,
    data: {
      email: "",
      mobile: "",
      message: "",
    },
  };
  toggleForm = (e) => {
    if (e) e.preventDefault();

    this.setState((prevState) => ({
      formModel: !prevState.formModel,
    }));
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    const { data } = this.state;

    if (name === "mobile") {
      data[name] = value.replace(/\D/g, "");
    } else {
      data[name] = value;
    }

    this.setState({
      data,
      formError: false,
    });
  };
  toggleFormSuccess = (e) => {
    if (e) e.preventDefault();
    this.setState({ formSuccessModel: !this.state.formSuccessModel });
  };

  doSubmit = (e) => {
    this.setState({ loading: true });
    if (e) e.preventDefault();
    const { data } = this.state;
    this.props.customerQuery(data, this.callback);
  };
  callback = (res) => {
    this.setState({ loading: false });

    if (res.status === 200) {
      this.setState({
        formModel: false,
        formSuccessModel: true,
        formError: false,
        data: {
          email: "",
          mobile: "",
          message: "",
        },
      });
    } else {
      this.setState({
        formError: true,
      });
    }
  };
  render() {
    const { email, mobile } = this.state.data;
    const isContactMissing =  !email && !mobile

    return (
      <>
        <div className="content-container block-intro-container">
          <div className="container container1">
            <div className="row thoughts-row add-blue-shape">
              <div className="col-lg-5">
                <div className="intro-text-box">
                  <h3>
                    Scribble
                    <span>Your Thoughts</span>
                  </h3>

                  <p>Do you wanna share it with us?</p>
                </div>
              </div>

              <div className="col-lg-7 mt-3">
                <div className="intro-textarea-content ml-auto">
                  <textarea
                    onChange={this.handleChange}
                    value={this.state.data.message}
                    name="message"
                    placeholder="Ask us something that's keeping you worried or stopping you from seeking help ..."
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-lg-5 thoughts-buttons">
                <div className="new-btn-group d-flex align-items-center">
                  <a
                    onClick={this.toggleForm}
                    href="#!"
                    className="btn btn-outline"
                    data-toggle="modal"
                    data-target="#yesbtn"
                  >
                    Yes
                  </a>

                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        data: {
                          email: "",
                          mobile: "",
                          message: "",
                        },
                      });
                    }}
                    href="#!"
                    className="btn btn-default"
                    data-toggle="modal"
                    data-target="#nobtn"
                  >
                    No
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          centered
          dialogClassName="modal-dialog modal-dialog-centered mt-0"
          // className="modal fade form-popup show"
          show={this.state.formModel}
          onHide={this.toggleForm}
        >
          <button
            onClick={this.toggleForm}
            type="button"
            className="close thoughts-modal-close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <img src={modelCloseIcon} alt="" />
          </button>

          
        <div className="modal-body thoughts-modal-body">
          <div className="thoughts-form">

            <h4 className="thoughts-form-heading">
              We will share your message with our experts
            </h4>

            <p className="thoughts-form-description">
              Will share their response here:
            </p>

            <div className="thoughts-form-fields">
              <div className="thoughts-form-field">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Email"
                  onChange={this.handleChange}
                  value={this.state.data.email}
                />
                <small>
                  ( strictly for one time response, no spam)
                </small>
              </div>

              <div className="thoughts-form-field">
                <input
                  type="tel"
                  className="form-control"
                  name="mobile"
                  placeholder="Contact No"
                  onChange={this.handleChange}
                  value={this.state.data.mobile}
                />
                <small>
                  ( No calls will be made, only one time response on whatsapp)
                </small>
              </div>
            </div>

            <div className="form-group mb-0">
              <button
                onClick={this.doSubmit}
                disabled={isContactMissing || this.state.loading}
                className={
                  isContactMissing || this.state.loading
                    ? "btn btn-primary disabled"
                    : "btn btn-primary"
                }
              >
                Share
              </button>

              {this.state.formError && (
                <label className="errorLabel">
                  Invalid information, Please fill valid information
                </label>
              )}
            </div>

            <div className="thoughts-form-footer">
              You may only fill your preferred communication channel.
              <br />
              The response may take up to few hours. We will be as quick as possible.
              <br />
              <p className="thoughts-contact">
                Please note this is not for Emergency. In case of crisis please call Tele-Manas 24hrs helpline - 1-800-891-441
              </p>   
            </div>

          </div>
        </div>
        </Modal>

        <Modal
          centered
          // dialogClassName="modal-dialog modal-dialog-centered mt-0"
          className="modal fade form-popup show"
          show={this.state.formSuccessModel}
          onHide={this.toggleFormSuccess}
        >
          <button
            onClick={this.toggleFormSuccess}
            type="button"
            className="close"
          >
            <img src={modelCloseIcon} alt="" />
          </button>
          <div className="modal-body d-flex align-items-center justify-content-center text-center">
            <div className="popup-content d-flex  flex-column align-items-center justify-content-center">
              <img src={mindIcon} alt="" />
              <h3>
                Your thoughts have been successfully shared with our experts
              </h3>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  getMisc: getMisc(state),
});

const mapDispatchToProps = (dispatch) => ({
  customerQuery: (data, callback) => dispatch(customerQuery(data, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Thoughts);
